module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "natasha.e6bdc94c.png";